import { BASE_URL } from 'libs/axios/axiosInstance';
import { apiService } from 'libs/axios/services';

export const resetPasswordFetcher = async (
    id: string,
    data: { password: string },
): Promise<ApiResponse<{ data: IUser }>> => {
    return apiService.patch<typeof data, { data: IUser }>(
        `${BASE_URL}/user/${id}/password-reissue`,
        data,
    );
};
